import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./reducers/language";

import { saveState, loadState } from "./localStorage";

const store = configureStore({
  reducer: {
    language: languageReducer,
  },
  preloadedState: loadState(),
});

store.subscribe(() => saveState(store.getState()));

export default store;
